var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Type } from "class-transformer";
import { Column, OneToMany } from "typeorm";
import { AccountingSalaryConfig } from "./model";
export class AccountingSettings {
    constructor(vals = {}) {
        this.client = "";
        this.consultant = "";
        this.cashbookLedger = "1600";
        this.realAccountsLength = 4;
        this.companyNumber = "";
        Object.assign(this, vals);
    }
}
__decorate([
    Column({ default: "" }),
    __metadata("design:type", String)
], AccountingSettings.prototype, "client", void 0);
__decorate([
    Column({ default: "" }),
    __metadata("design:type", String)
], AccountingSettings.prototype, "consultant", void 0);
__decorate([
    Column({ default: "1600" }),
    __metadata("design:type", String)
], AccountingSettings.prototype, "cashbookLedger", void 0);
__decorate([
    Column({ default: 4 }),
    __metadata("design:type", Number)
], AccountingSettings.prototype, "realAccountsLength", void 0);
__decorate([
    Column({ default: "" }),
    __metadata("design:type", String)
], AccountingSettings.prototype, "companyNumber", void 0);
__decorate([
    Type(() => AccountingSalaryConfig),
    OneToMany(() => AccountingSalaryConfig, (v) => v.settings, { eager: true, cascade: true }),
    __metadata("design:type", Array)
], AccountingSettings.prototype, "salaryConfigs", void 0);
export class AbsenceAccountingSalaryConfig {
    constructor(vals = {}) {
        this.vacation = "";
        this.compDay = "";
        this.sick = "";
        this.childSick = "";
        this.sickInKUG = "";
        Object.assign(this, vals);
    }
}
__decorate([
    Column({ default: "" }),
    __metadata("design:type", String)
], AbsenceAccountingSalaryConfig.prototype, "vacation", void 0);
__decorate([
    Column({ default: "" }),
    __metadata("design:type", String)
], AbsenceAccountingSalaryConfig.prototype, "compDay", void 0);
__decorate([
    Column({ default: "" }),
    __metadata("design:type", String)
], AbsenceAccountingSalaryConfig.prototype, "sick", void 0);
__decorate([
    Column({ default: "" }),
    __metadata("design:type", String)
], AbsenceAccountingSalaryConfig.prototype, "childSick", void 0);
__decorate([
    Column({ default: "" }),
    __metadata("design:type", String)
], AbsenceAccountingSalaryConfig.prototype, "sickInKUG", void 0);
export class BonusAccountingSalaryConfig {
    constructor(vals = {}) {
        this.night1 = "";
        this.night2 = "";
        this.sunday = "";
        this.holiday = "";
        this.special = "";
        Object.assign(this, vals);
    }
}
__decorate([
    Column({ default: "" }),
    __metadata("design:type", String)
], BonusAccountingSalaryConfig.prototype, "night1", void 0);
__decorate([
    Column({ default: "" }),
    __metadata("design:type", String)
], BonusAccountingSalaryConfig.prototype, "night2", void 0);
__decorate([
    Column({ default: "" }),
    __metadata("design:type", String)
], BonusAccountingSalaryConfig.prototype, "sunday", void 0);
__decorate([
    Column({ default: "" }),
    __metadata("design:type", String)
], BonusAccountingSalaryConfig.prototype, "holiday", void 0);
__decorate([
    Column({ default: "" }),
    __metadata("design:type", String)
], BonusAccountingSalaryConfig.prototype, "special", void 0);
//# sourceMappingURL=model.embedded.js.map